import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { isUndefined, omitBy } from 'lodash';
import { map, Observable } from 'rxjs';
import { LeadInjector } from 'src/app/core/models/lead/lead-injector.model';
import { LeadInjectorCreateDto, LeadInjectorUpdateDto } from 'src/app/infrastructure/lobby-proxy/DTOs/lead-injector.dto';
import { LeadInjectorProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-lead-injector/lead-injector-proxy.service';
import { LeadInjectorDtoToLeadInjector } from 'src/app/shared/mappings/lead-model-dto/lead-injector.mapping';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class LeadInjectorInfoService {

  constructor(private readonly leadInjectorProxyService: LeadInjectorProxyService) {
  }

  createLeadInjector$(injector: LeadInjector): Observable<LeadInjector> {

    console.log('injector', injector)

    const dto: LeadInjectorCreateDto = {
      activationBegin: this.getJsonDate(injector.activationBegin),
      activationEnd: this.getJsonDate(injector.activationEnd),
      description: injector.description,
      isEnabled: injector.isEnabled,
      isAutoOfferingEnabled: injector.isAutoOfferEnabled,
      domainList: injector.domains || [],
      ipList: injector.ipAddresses || [],

      note: injector.note
    }

    return this.leadInjectorProxyService.postLeadInjector$(dto).pipe(
      throwIfLobbyErrorCode,
      map(dto => LeadInjectorDtoToLeadInjector(dto.data)!)
    )
  }
  getJsonDate(date: Date | null) {
    if (!date) return null
    const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds())
    return new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000)).toJSON()
  }
  updateLeadInjectorInfo$(newLeadInjectorInfo: LeadInjector, oldLeadInjectorInfo: LeadInjector): Observable<LeadInjector> {

    const patchDto = {
      activationBegin: newLeadInjectorInfo.activationBegin != oldLeadInjectorInfo.activationBegin ? this.getJsonDate(newLeadInjectorInfo.activationBegin) : undefined,
      activationEnd: newLeadInjectorInfo.activationEnd != oldLeadInjectorInfo.activationEnd ? this.getJsonDate(newLeadInjectorInfo.activationEnd) : undefined,

      description: (newLeadInjectorInfo.description != oldLeadInjectorInfo.description) && newLeadInjectorInfo.description?.length ? newLeadInjectorInfo.description : undefined,
      note: (newLeadInjectorInfo.note != oldLeadInjectorInfo.note) && newLeadInjectorInfo.note?.length ? newLeadInjectorInfo.note : undefined,

      removeDescription: !newLeadInjectorInfo.description?.length,
      removeNote: !newLeadInjectorInfo.note?.length,

      isEnabled: newLeadInjectorInfo.isEnabled != oldLeadInjectorInfo.isEnabled ? newLeadInjectorInfo.isEnabled : undefined,
      isAutoOfferingEnabled: newLeadInjectorInfo.isAutoOfferEnabled != oldLeadInjectorInfo.isAutoOfferEnabled ? newLeadInjectorInfo.isAutoOfferEnabled : undefined,

      dnsDomainsWhitelist: newLeadInjectorInfo.domains != oldLeadInjectorInfo.domains ? newLeadInjectorInfo.domains : undefined,
      ipAddressesWhitelist: newLeadInjectorInfo.ipAddresses != oldLeadInjectorInfo.ipAddresses ? newLeadInjectorInfo.ipAddresses : undefined
    } as LeadInjectorUpdateDto

    return this.leadInjectorProxyService.patchLeadInjector$(newLeadInjectorInfo.id!, omitBy(patchDto, isUndefined) as LeadInjectorUpdateDto, newLeadInjectorInfo.version).pipe(
      throwIfLobbyErrorCode,
      map(dto => LeadInjectorDtoToLeadInjector(dto.data)!)
    )

  }
}
